module.exports = __webpack_public_path__ + "fonts/brandon-grotesque-thin-italic-58a8a3a8861fe.1a2721b.woff2";